import React from 'react'
import { Form, Input, Row, Col } from 'antd'
import { useTranslation } from 'react-i18next'

export const languageFields = {
  fin: 'nameFi',
  eng: 'nameEn',
  swe: 'nameSv'
} as const

type LanguageFields = typeof languageFields

type LanguageCode = keyof LanguageFields

export type LanguageField = (typeof languageFields)[LanguageCode]

export type TranslationFields = {
  [key in LanguageField]: string
}

type TranslateFieldsProps = {
  inline?: boolean
}

const TranslateFields: React.FC<TranslateFieldsProps> = ({ inline = false }) => {
  const { t } = useTranslation()

  const items = Object.entries(languageFields).map(([lng, field]) => {
    const label = t('global:translation', { language: lng.toUpperCase() })

    const formItem = (
      <Form.Item label={label} name={field} key={lng}>
        <Input />
      </Form.Item>
    )

    return inline ? (
      <Col span={8} key={lng}>
        {formItem}
      </Col>
    ) : (
      formItem
    )
  })

  return inline ? <Row gutter={16}>{items}</Row> : <>{items}</>
}

export default TranslateFields
